/**
 * Representa os estados possíveis durante o envio de um arquivo para o servidor.
 * 
 * Estados possíveis:
 * 
 * - IDLE = 0: nenhum envio ocorrendo no momento.
 * - SENDING = 1: uma transferência de arquivo está acontecendo.
 * - FINISHED = 2: a transferência de arquivo terminou, independentemente de ser sucesso ou falha.
 */
export enum FileUploadStatus {
  IDLE = 0,
  SENDING = 1,
  FINISHED = 2
}